import React from 'react'

export type VideoContext = {
    isMuted: boolean
    isBlurred: boolean
    firstVideoReady: boolean
    isLPM: boolean
    videoTapped: boolean
    shouldPlay: boolean

    setIsBlurred: React.Dispatch<React.SetStateAction<boolean>>
    setIsMuted: React.Dispatch<React.SetStateAction<boolean>>
    setFirstVideoReady: React.Dispatch<React.SetStateAction<boolean>>
    setIsLPM: React.Dispatch<React.SetStateAction<boolean>>
    setVideoTapped: React.Dispatch<React.SetStateAction<boolean>>
    setShouldPlay: React.Dispatch<React.SetStateAction<boolean>>
}

const DefaultVideoContext: VideoContext = {
    isMuted: true,
    isBlurred: false,
    firstVideoReady: false,
    isLPM: false,
    videoTapped: false,
    shouldPlay: true,
    setIsBlurred: (..._args: any) => {},
    setIsMuted: (..._args: any) => {},
    setFirstVideoReady: (..._args: any) => {},
    setIsLPM: (..._args: any) => {},
    setVideoTapped: () => {},
    setShouldPlay: () => {},
}

export const VideoContext =
    React.createContext<VideoContext>(DefaultVideoContext)
